export default {
	"productGroupPageContent.title":
		"Unsere Versicherungslösungen im Überblick:",
	"productGroupPageContent.pageTitle":
		"{name} — Unsere Versicherungslösungen im Überblick:",
	"productGroupPageContent.detailsCta": "Produktdetails",
	"targetGroupPageContent.pageTitle": "{productName} für {targetGroupName}",
} as const;
